import './src/styles/global.scss';
import wrapWithProvider from './src/states/redux-wrappger';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = wrapWithProvider;
